var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sig-box"},[_c('canvas',{ref:"canvas"})]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-link btn-sm p-0",attrs:{"type":"button"},on:{"click":_vm.clear}},[_vm._v("Clear signature")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }